import clsx from 'clsx';
import { Ref, forwardRef, useEffect } from 'react';
import { Primitive } from 'zod';

import './ToggleControl.scss';

type ToggleControlProps<T extends Primitive, V extends Primitive> = {
    options: [{ value: T; label: string }, { value: V; label: string }];
    defaultValue: T | V;
    value: T | V | undefined;
    onChange: (value: T | V) => void;
};

export default forwardRef(function ToggleControl<T extends Primitive, V extends Primitive>(
    props: ToggleControlProps<T, V>,
    ref: Ref<HTMLDivElement>,
) {
    const { onChange, defaultValue, options, value: propsValue } = props;
    useEffect(() => {
        if (propsValue === undefined) {
            onChange(defaultValue);
        }
    }, [propsValue]);
    return (
        <div ref={ref} className="toggle">
            {options.map(({ value, label }) => (
                <button
                    type="button"
                    key={JSON.stringify(value)}
                    onClick={() => {
                        onChange(value);
                    }}
                    className={clsx(propsValue === value && 'selected')}
                >
                    {label}
                </button>
            ))}
        </div>
    );
});
